import { render, staticRenderFns } from "./site_page.vue?vue&type=template&id=3072b4e2&"
import script from "./site_page.vue?vue&type=script&lang=js&"
export * from "./site_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports